import * as React from 'react';

import { useBoolean, useLockFn } from 'ahooks';
import { Button, Divider, Form, Modal, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { CheckOutlinedIcon, DeleteOutlinedIcon } from 'components';
import { useAttributeValue } from 'context';
import { deleteAttributeConfig } from 'services';
import { PATHNAME } from 'utils';

const {
  LOCAL: {
    ATTRIBUTES: { BASE_URL: ATTRIBUTES_BASE_URL },
  },
} = PATHNAME;

const AttributeFormAction = () => {
  const [deleteModalInstance, deleteModalContextHolder] = Modal.useModal();
  const [deleteLoading, { toggle: toggleDeleteLoading }] = useBoolean();
  const { id, mode } = useAttributeValue();
  const navigate = useNavigate();

  const handleDeleteAttributeConfig = useLockFn(
    async ({
      id,
    }: Pick<Required<ReturnType<typeof useAttributeValue>>, 'id'>) => {
      toggleDeleteLoading();

      deleteAttributeConfig({ id })
        .then(() => {
          navigate(ATTRIBUTES_BASE_URL);
          notification.success({
            message: 'فیلد با موفقیت حذف شد.',
          });
        })
        .catch(message => {
          notification.error({
            message,
          });
        })
        .finally(() => {
          toggleDeleteLoading();
        });
    },
  );

  return (
    <div>
      <div className='px-6 pt-4'>
        <Typography.Title level={3} className='mb-0 text-base font-medium'>
          انتشار فیلد
        </Typography.Title>
      </div>

      <Divider className='mb-8 mt-4' />

      <div className='px-6'>
        <Typography.Paragraph>
          از طریق این بخش می‌توانید فیلد ساخته شده و یا ویرایش شده را منتشر
          کنید.
        </Typography.Paragraph>
      </div>

      <div className='flex flex-wrap-reverse items-center gap-2 p-6 *:m-0 *:shrink *:grow *:basis-40'>
        {mode === 'Update' ? (
          <Form.Item>
            <Button
              block
              danger
              className='flex items-center'
              loading={deleteLoading}
              icon={<DeleteOutlinedIcon />}
              onClick={async () => {
                const confirmed = await deleteModalInstance.confirm({
                  title: 'آیا از حذف این فیلد اطمینان دارید؟',
                  width: 500,
                });
                if (id && confirmed) {
                  handleDeleteAttributeConfig({ id });
                }
              }}
            >
              <span>حذف فیلد</span>
            </Button>
            {deleteModalContextHolder}
          </Form.Item>
        ) : null}

        <Form.Item>
          <Button
            block
            type='primary'
            htmlType='submit'
            icon={<CheckOutlinedIcon />}
          >
            {mode === 'Create' ? (
              <span>افزودن فیلد جدید</span>
            ) : (
              <span>ذخیره تغییرات</span>
            )}
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export { AttributeFormAction };
